<template>
  <div>
    <div aria-hidden="true" class="onboarding-modal modal fade animated" id="aggrentenciones" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center" style="width: 100%; max-width: 100%">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <h3 class="text-success font-weight-bold">
                AGREGAR RENTENCIÓN &nbsp;&nbsp;
                <i class="fas fa-file-alt"></i>
              </h3>
              <div class="row col-12">
                <div class="col-3">
                  <label>Fecha retención</label>
                  <input placeholder="Fecha" v-model="current.fecha_retencion" type="date" class="form-control" />
                  <small class="text-danger" v-if="current.errors && current.errors.fecha_retencion">{{
                    current.errors.fecha_retencion }}</small>
                </div>
                <div class="col-4">
                  <label>Retención # (Constancia)</label>
                  <input placeholder="#" rows="1" class="form-control" v-model="current.constancia">
                  <small class="text-danger" v-if="current.errors && current.errors.constancia">{{
                    current.errors.constancia }}</small>
                </div>
                <div class="col-5">
                  <label>Tipo de Impuesto</label>
                  <select class="form-control form-control-sm" autofocus="autofocus" v-model="current.tipo_impuesto">
                    <option value="">----</option>
                    <option v-for="(c, key) in tipoRetenciones" :value="c.codigo" :key="key">
                      {{ c.codigo }} - {{ c.nombre }}
                    </option>
                  </select>
                  <small class="text-danger" v-if="current.errors && current.errors.tipo_impuesto">{{
                    current.errors.tipo_impuesto }}</small>
                </div>
                <div class="row col-12">
                  <div class="col-4">
                    <label>Importe Bruto</label>
                    <input placeholder="Q." v-model="current.total_cargo" type="text" style="text-align: right;"
                      class="form-control" />
                    <small class="text-danger" v-if="current.errors && current.errors.total_cargo">{{
                      current.errors.total_cargo }}</small>
                  </div>
                  <div class="col-3">
                    <label>Tasa Retención (%)</label>
                    <input placeholder="%" v-model="current.porc_ret" type="text" style="text-align: right;"
                      class="form-control" />
                    <small class="text-danger" v-if="current.errors && current.errors.porc_ret">{{ current.errors.porc_ret
                    }}</small>
                  </div>
                  <div class="col-5">
                    <label>Total Retención</label>
                    <input placeholder="Q." v-model="current.total_ret" type="text"
                      style="text-align: right;" class="form-control" />
                    <small class="text-danger" v-if="current.errors && current.errors.total_ret">{{
                      current.errors.total_ret
                    }}</small>
                  </div>
                </div>
              </div>
              <div style="border-radius: 10px" class="row col-12">
                <div class="col-10 text-dark">
                  <CuentaContableSelectComponent :propname="'cuenta_contable'" :label="'Cuenta Contable Afecta'"
                    :current="current" />
                </div>
                <div class="col-2" style="clear: both;">
                  <br />
                  <button class="btn btn-success" @click="AgregarRetencion()">
                    Agregar <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import CentroCostoSelectComponent from "@/components/commons/CentroCostoSelectComponent";

export default {
  props: ["current_", "current_cargod"],
  components: {
    UsuarioEnTablaComponent,
    TiendaSelectComponent,
    CuentaContableSelectComponent,
    CentroCostoSelectComponent,
  },
  data() {
    return {
      current: {
        tipo_impuesto: "",
        cuenta_contable: 0,
        total_cargo: 0,
        total_ret: 0,
        porc_ret: 0,
        errors: [],
      },
      tipoRetenciones: [],
      current_filter: {},
      dataTabla: [],
      mostrarRefresh: false,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {},
  mounted() {
    let self = this;
    self.refreshTiposRetenciones();
  },
  methods: {
    refreshTiposRetenciones() {
      let self = this;
      DynamicService.fetch("cxp", "tipo-retencion", {
        quitar_paginacion: true,
      }).then((res) => {
        self.tipoRetenciones = res.data;
      });
    },
    cleanCurrentDefault() {
      let self = this;
      self.current = {
        cuenta_contable: "",
      };
      self.currentContable = {
        cuenta_contable: "",
        centro_cost: "",
        cargo: 0,
        abono: 0,
        errors: [],
      };
    },
    AgregarRetencion() {
      let self = this;
      self.current.cargo_d = self.current_cargod.id;
      self.current.cuenta_contable = self.current.cuenta_contable.id;
      if (self.current.fecha_retencion) {
        self.current.fecha_retencion = moment(self.current.fecha_retencion).format(
          "DD/MM/YYYY"
        );
      }
      self.current.cargo_d = self.current_cargod.id;
      console.log(self.current);
      DynamicService.postAction(
        "cxp",
        "cargos",
        self.current_.id,
        "agregar_detalle_retencion",
        self.current
      )
        .then((res) => {
          self.cleanCurrentDefault();
          Notifications.toast.success("Agregar retención", "Generado correctamente");
          $("#aggrentenciones").modal("hide");
          self.$emit("refreshCargo");
        })
        .catch((err) => {
          self.current.errors = err.response.data;
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Agregar póliza contable",
              err.response.data.detail
            );
          }
        });
    },
  },
};
</script>
